package com.eladfinish.bible.contest

import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.`internal`.SupportedLocale
import dev.icerock.moko.resources.`internal`.SupportedLocales
import dev.icerock.moko.resources.provider.RemoteJsStringLoader
import kotlin.String
import kotlin.collections.List

private val fallbackFileUrl: String =
    js("require(\"./localization/comeladfinishbiblecontest_stringsJson.json\")") as String

private val supportedLocales: SupportedLocales = SupportedLocales(listOf(
    SupportedLocale("de",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_de.json\")") as String),
    SupportedLocale("en",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_en.json\")") as String),
    SupportedLocale("es",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_es.json\")") as String),
    SupportedLocale("fr",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_fr.json\")") as String),
    SupportedLocale("ru",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_ru.json\")") as String),
    ))

private val stringsLoader: RemoteJsStringLoader = RemoteJsStringLoader.Impl(supportedLocales =
    supportedLocales, fallbackFileUri = fallbackFileUrl)

internal object CommonMainStrings6 {
  internal val open_questions_shuffle_title: StringResource by lazy {
      init_open_questions_shuffle_title() }

  internal val ot_aleph: StringResource by lazy { init_ot_aleph() }

  internal val ot_bet: StringResource by lazy { init_ot_bet() }

  internal val ot_dalet: StringResource by lazy { init_ot_dalet() }

  internal val ot_gimmel: StringResource by lazy { init_ot_gimmel() }

  internal val otiot_sofiot: StringResource by lazy { init_otiot_sofiot() }

  internal val otiot_sofiot_final_form: StringResource by lazy { init_otiot_sofiot_final_form() }

  internal val pager: StringResource by lazy { init_pager() }

  internal val pair_is_not_matched_to: StringResource by lazy { init_pair_is_not_matched_to() }

  internal val pair_list_of: StringResource by lazy { init_pair_list_of() }

  internal val pair_matching: StringResource by lazy { init_pair_matching() }

  internal val pair_matching_alphabetical_order_disabled: StringResource by lazy {
      init_pair_matching_alphabetical_order_disabled() }

  internal val pair_matching_alphabetical_order_enabled: StringResource by lazy {
      init_pair_matching_alphabetical_order_enabled() }

  internal val pair_matching_progress_format: StringResource by lazy {
      init_pair_matching_progress_format() }

  internal val parasha_not_found: StringResource by lazy { init_parasha_not_found() }

  internal val parashah: StringResource by lazy { init_parashah() }

  internal val parashat: StringResource by lazy { init_parashat() }

  internal val parashat_haman: StringResource by lazy { init_parashat_haman() }

  internal val parashat_haman_ending: StringResource by lazy { init_parashat_haman_ending() }

  internal val parashat_haman_intro: StringResource by lazy { init_parashat_haman_intro() }

  internal val parashat_hashavua: StringResource by lazy { init_parashat_hashavua() }

  internal val parashat_hashavua_placeholder: StringResource by lazy {
      init_parashat_hashavua_placeholder() }

  internal val parashot: StringResource by lazy { init_parashot() }

  internal val past_quizzes: StringResource by lazy { init_past_quizzes() }

  internal val past_quizzes_sheet_cta: StringResource by lazy { init_past_quizzes_sheet_cta() }

  internal val past_quizzes_sheet_footer: StringResource by lazy { init_past_quizzes_sheet_footer()
      }

  internal val past_quizzes_sheet_intro: StringResource by lazy { init_past_quizzes_sheet_intro() }

  internal val past_quizzes_sheet_point_duel_body: StringResource by lazy {
      init_past_quizzes_sheet_point_duel_body() }

  internal val past_quizzes_sheet_point_duel_lead: StringResource by lazy {
      init_past_quizzes_sheet_point_duel_lead() }

  internal val past_quizzes_sheet_point_peek_body: StringResource by lazy {
      init_past_quizzes_sheet_point_peek_body() }

  internal val past_quizzes_sheet_point_peek_lead: StringResource by lazy {
      init_past_quizzes_sheet_point_peek_lead() }

  internal val past_quizzes_sheet_point_practice_body: StringResource by lazy {
      init_past_quizzes_sheet_point_practice_body() }

  internal val past_quizzes_sheet_point_practice_lead: StringResource by lazy {
      init_past_quizzes_sheet_point_practice_lead() }

  internal val past_quizzes_sheet_point_voice_body: StringResource by lazy {
      init_past_quizzes_sheet_point_voice_body() }

  internal val past_quizzes_sheet_point_voice_lead: StringResource by lazy {
      init_past_quizzes_sheet_point_voice_lead() }

  internal val past_quizzes_sheet_tag: StringResource by lazy { init_past_quizzes_sheet_tag() }

  internal val past_quizzes_sheet_title: StringResource by lazy { init_past_quizzes_sheet_title() }

  internal val paste_text: StringResource by lazy { init_paste_text() }

  internal val pasuk_example: StringResource by lazy { init_pasuk_example() }

  internal val pasuk_example_bereshit: StringResource by lazy { init_pasuk_example_bereshit() }

  internal val pasuk_lehazmana: StringResource by lazy { init_pasuk_lehazmana() }

  internal val pasuk_str: StringResource by lazy { init_pasuk_str() }

  internal val pdf_email_dialog_email: StringResource by lazy { init_pdf_email_dialog_email() }

  internal val pdf_email_dialog_first_name: StringResource by lazy {
      init_pdf_email_dialog_first_name() }

  internal val pdf_email_dialog_invalid_email: StringResource by lazy {
      init_pdf_email_dialog_invalid_email() }

  internal val pdf_email_dialog_last_name: StringResource by lazy {
      init_pdf_email_dialog_last_name() }

  internal val pdf_email_dialog_save_details: StringResource by lazy {
      init_pdf_email_dialog_save_details() }

  internal val pdf_email_dialog_title: StringResource by lazy { init_pdf_email_dialog_title() }

  internal val perek_a: StringResource by lazy { init_perek_a() }

  internal val perek_str: StringResource by lazy { init_perek_str() }

  internal fun values(): List<StringResource> = listOf(open_questions_shuffle_title, ot_aleph,
      ot_bet, ot_dalet, ot_gimmel, otiot_sofiot, otiot_sofiot_final_form, pager,
      pair_is_not_matched_to, pair_list_of, pair_matching,
      pair_matching_alphabetical_order_disabled, pair_matching_alphabetical_order_enabled,
      pair_matching_progress_format, parasha_not_found, parashah, parashat, parashat_haman,
      parashat_haman_ending, parashat_haman_intro, parashat_hashavua, parashat_hashavua_placeholder,
      parashot, past_quizzes, past_quizzes_sheet_cta, past_quizzes_sheet_footer,
      past_quizzes_sheet_intro, past_quizzes_sheet_point_duel_body,
      past_quizzes_sheet_point_duel_lead, past_quizzes_sheet_point_peek_body,
      past_quizzes_sheet_point_peek_lead, past_quizzes_sheet_point_practice_body,
      past_quizzes_sheet_point_practice_lead, past_quizzes_sheet_point_voice_body,
      past_quizzes_sheet_point_voice_lead, past_quizzes_sheet_tag, past_quizzes_sheet_title,
      paste_text, pasuk_example, pasuk_example_bereshit, pasuk_lehazmana, pasuk_str,
      pdf_email_dialog_email, pdf_email_dialog_first_name, pdf_email_dialog_invalid_email,
      pdf_email_dialog_last_name, pdf_email_dialog_save_details, pdf_email_dialog_title, perek_a,
      perek_str)
}

private fun init_open_questions_shuffle_title(): StringResource = StringResource(key =
    "open_questions_shuffle_title", loader = stringsLoader)

private fun init_ot_aleph(): StringResource = StringResource(key = "ot_aleph", loader =
    stringsLoader)

private fun init_ot_bet(): StringResource = StringResource(key = "ot_bet", loader = stringsLoader)

private fun init_ot_dalet(): StringResource = StringResource(key = "ot_dalet", loader =
    stringsLoader)

private fun init_ot_gimmel(): StringResource = StringResource(key = "ot_gimmel", loader =
    stringsLoader)

private fun init_otiot_sofiot(): StringResource = StringResource(key = "otiot_sofiot", loader =
    stringsLoader)

private fun init_otiot_sofiot_final_form(): StringResource = StringResource(key =
    "otiot_sofiot_final_form", loader = stringsLoader)

private fun init_pager(): StringResource = StringResource(key = "pager", loader = stringsLoader)

private fun init_pair_is_not_matched_to(): StringResource = StringResource(key =
    "pair_is_not_matched_to", loader = stringsLoader)

private fun init_pair_list_of(): StringResource = StringResource(key = "pair_list_of", loader =
    stringsLoader)

private fun init_pair_matching(): StringResource = StringResource(key = "pair_matching", loader =
    stringsLoader)

private fun init_pair_matching_alphabetical_order_disabled(): StringResource = StringResource(key =
    "pair_matching_alphabetical_order_disabled", loader = stringsLoader)

private fun init_pair_matching_alphabetical_order_enabled(): StringResource = StringResource(key =
    "pair_matching_alphabetical_order_enabled", loader = stringsLoader)

private fun init_pair_matching_progress_format(): StringResource = StringResource(key =
    "pair_matching_progress_format", loader = stringsLoader)

private fun init_parasha_not_found(): StringResource = StringResource(key = "parasha_not_found",
    loader = stringsLoader)

private fun init_parashah(): StringResource = StringResource(key = "parashah", loader =
    stringsLoader)

private fun init_parashat(): StringResource = StringResource(key = "parashat", loader =
    stringsLoader)

private fun init_parashat_haman(): StringResource = StringResource(key = "parashat_haman", loader =
    stringsLoader)

private fun init_parashat_haman_ending(): StringResource = StringResource(key =
    "parashat_haman_ending", loader = stringsLoader)

private fun init_parashat_haman_intro(): StringResource = StringResource(key =
    "parashat_haman_intro", loader = stringsLoader)

private fun init_parashat_hashavua(): StringResource = StringResource(key = "parashat_hashavua",
    loader = stringsLoader)

private fun init_parashat_hashavua_placeholder(): StringResource = StringResource(key =
    "parashat_hashavua_placeholder", loader = stringsLoader)

private fun init_parashot(): StringResource = StringResource(key = "parashot", loader =
    stringsLoader)

private fun init_past_quizzes(): StringResource = StringResource(key = "past_quizzes", loader =
    stringsLoader)

private fun init_past_quizzes_sheet_cta(): StringResource = StringResource(key =
    "past_quizzes_sheet_cta", loader = stringsLoader)

private fun init_past_quizzes_sheet_footer(): StringResource = StringResource(key =
    "past_quizzes_sheet_footer", loader = stringsLoader)

private fun init_past_quizzes_sheet_intro(): StringResource = StringResource(key =
    "past_quizzes_sheet_intro", loader = stringsLoader)

private fun init_past_quizzes_sheet_point_duel_body(): StringResource = StringResource(key =
    "past_quizzes_sheet_point_duel_body", loader = stringsLoader)

private fun init_past_quizzes_sheet_point_duel_lead(): StringResource = StringResource(key =
    "past_quizzes_sheet_point_duel_lead", loader = stringsLoader)

private fun init_past_quizzes_sheet_point_peek_body(): StringResource = StringResource(key =
    "past_quizzes_sheet_point_peek_body", loader = stringsLoader)

private fun init_past_quizzes_sheet_point_peek_lead(): StringResource = StringResource(key =
    "past_quizzes_sheet_point_peek_lead", loader = stringsLoader)

private fun init_past_quizzes_sheet_point_practice_body(): StringResource = StringResource(key =
    "past_quizzes_sheet_point_practice_body", loader = stringsLoader)

private fun init_past_quizzes_sheet_point_practice_lead(): StringResource = StringResource(key =
    "past_quizzes_sheet_point_practice_lead", loader = stringsLoader)

private fun init_past_quizzes_sheet_point_voice_body(): StringResource = StringResource(key =
    "past_quizzes_sheet_point_voice_body", loader = stringsLoader)

private fun init_past_quizzes_sheet_point_voice_lead(): StringResource = StringResource(key =
    "past_quizzes_sheet_point_voice_lead", loader = stringsLoader)

private fun init_past_quizzes_sheet_tag(): StringResource = StringResource(key =
    "past_quizzes_sheet_tag", loader = stringsLoader)

private fun init_past_quizzes_sheet_title(): StringResource = StringResource(key =
    "past_quizzes_sheet_title", loader = stringsLoader)

private fun init_paste_text(): StringResource = StringResource(key = "paste_text", loader =
    stringsLoader)

private fun init_pasuk_example(): StringResource = StringResource(key = "pasuk_example", loader =
    stringsLoader)

private fun init_pasuk_example_bereshit(): StringResource = StringResource(key =
    "pasuk_example_bereshit", loader = stringsLoader)

private fun init_pasuk_lehazmana(): StringResource = StringResource(key = "pasuk_lehazmana", loader
    = stringsLoader)

private fun init_pasuk_str(): StringResource = StringResource(key = "pasuk_str", loader =
    stringsLoader)

private fun init_pdf_email_dialog_email(): StringResource = StringResource(key =
    "pdf_email_dialog_email", loader = stringsLoader)

private fun init_pdf_email_dialog_first_name(): StringResource = StringResource(key =
    "pdf_email_dialog_first_name", loader = stringsLoader)

private fun init_pdf_email_dialog_invalid_email(): StringResource = StringResource(key =
    "pdf_email_dialog_invalid_email", loader = stringsLoader)

private fun init_pdf_email_dialog_last_name(): StringResource = StringResource(key =
    "pdf_email_dialog_last_name", loader = stringsLoader)

private fun init_pdf_email_dialog_save_details(): StringResource = StringResource(key =
    "pdf_email_dialog_save_details", loader = stringsLoader)

private fun init_pdf_email_dialog_title(): StringResource = StringResource(key =
    "pdf_email_dialog_title", loader = stringsLoader)

private fun init_perek_a(): StringResource = StringResource(key = "perek_a", loader = stringsLoader)

private fun init_perek_str(): StringResource = StringResource(key = "perek_str", loader =
    stringsLoader)

public actual val SharedRes.strings.open_questions_shuffle_title: StringResource
  get() = CommonMainStrings6.open_questions_shuffle_title

public actual val SharedRes.strings.ot_aleph: StringResource
  get() = CommonMainStrings6.ot_aleph

public actual val SharedRes.strings.ot_bet: StringResource
  get() = CommonMainStrings6.ot_bet

public actual val SharedRes.strings.ot_dalet: StringResource
  get() = CommonMainStrings6.ot_dalet

public actual val SharedRes.strings.ot_gimmel: StringResource
  get() = CommonMainStrings6.ot_gimmel

public actual val SharedRes.strings.otiot_sofiot: StringResource
  get() = CommonMainStrings6.otiot_sofiot

public actual val SharedRes.strings.otiot_sofiot_final_form: StringResource
  get() = CommonMainStrings6.otiot_sofiot_final_form

public actual val SharedRes.strings.pager: StringResource
  get() = CommonMainStrings6.pager

public actual val SharedRes.strings.pair_is_not_matched_to: StringResource
  get() = CommonMainStrings6.pair_is_not_matched_to

public actual val SharedRes.strings.pair_list_of: StringResource
  get() = CommonMainStrings6.pair_list_of

public actual val SharedRes.strings.pair_matching: StringResource
  get() = CommonMainStrings6.pair_matching

public actual val SharedRes.strings.pair_matching_alphabetical_order_disabled: StringResource
  get() = CommonMainStrings6.pair_matching_alphabetical_order_disabled

public actual val SharedRes.strings.pair_matching_alphabetical_order_enabled: StringResource
  get() = CommonMainStrings6.pair_matching_alphabetical_order_enabled

public actual val SharedRes.strings.pair_matching_progress_format: StringResource
  get() = CommonMainStrings6.pair_matching_progress_format

public actual val SharedRes.strings.parasha_not_found: StringResource
  get() = CommonMainStrings6.parasha_not_found

public actual val SharedRes.strings.parashah: StringResource
  get() = CommonMainStrings6.parashah

public actual val SharedRes.strings.parashat: StringResource
  get() = CommonMainStrings6.parashat

public actual val SharedRes.strings.parashat_haman: StringResource
  get() = CommonMainStrings6.parashat_haman

public actual val SharedRes.strings.parashat_haman_ending: StringResource
  get() = CommonMainStrings6.parashat_haman_ending

public actual val SharedRes.strings.parashat_haman_intro: StringResource
  get() = CommonMainStrings6.parashat_haman_intro

public actual val SharedRes.strings.parashat_hashavua: StringResource
  get() = CommonMainStrings6.parashat_hashavua

public actual val SharedRes.strings.parashat_hashavua_placeholder: StringResource
  get() = CommonMainStrings6.parashat_hashavua_placeholder

public actual val SharedRes.strings.parashot: StringResource
  get() = CommonMainStrings6.parashot

public actual val SharedRes.strings.past_quizzes: StringResource
  get() = CommonMainStrings6.past_quizzes

public actual val SharedRes.strings.past_quizzes_sheet_cta: StringResource
  get() = CommonMainStrings6.past_quizzes_sheet_cta

public actual val SharedRes.strings.past_quizzes_sheet_footer: StringResource
  get() = CommonMainStrings6.past_quizzes_sheet_footer

public actual val SharedRes.strings.past_quizzes_sheet_intro: StringResource
  get() = CommonMainStrings6.past_quizzes_sheet_intro

public actual val SharedRes.strings.past_quizzes_sheet_point_duel_body: StringResource
  get() = CommonMainStrings6.past_quizzes_sheet_point_duel_body

public actual val SharedRes.strings.past_quizzes_sheet_point_duel_lead: StringResource
  get() = CommonMainStrings6.past_quizzes_sheet_point_duel_lead

public actual val SharedRes.strings.past_quizzes_sheet_point_peek_body: StringResource
  get() = CommonMainStrings6.past_quizzes_sheet_point_peek_body

public actual val SharedRes.strings.past_quizzes_sheet_point_peek_lead: StringResource
  get() = CommonMainStrings6.past_quizzes_sheet_point_peek_lead

public actual val SharedRes.strings.past_quizzes_sheet_point_practice_body: StringResource
  get() = CommonMainStrings6.past_quizzes_sheet_point_practice_body

public actual val SharedRes.strings.past_quizzes_sheet_point_practice_lead: StringResource
  get() = CommonMainStrings6.past_quizzes_sheet_point_practice_lead

public actual val SharedRes.strings.past_quizzes_sheet_point_voice_body: StringResource
  get() = CommonMainStrings6.past_quizzes_sheet_point_voice_body

public actual val SharedRes.strings.past_quizzes_sheet_point_voice_lead: StringResource
  get() = CommonMainStrings6.past_quizzes_sheet_point_voice_lead

public actual val SharedRes.strings.past_quizzes_sheet_tag: StringResource
  get() = CommonMainStrings6.past_quizzes_sheet_tag

public actual val SharedRes.strings.past_quizzes_sheet_title: StringResource
  get() = CommonMainStrings6.past_quizzes_sheet_title

public actual val SharedRes.strings.paste_text: StringResource
  get() = CommonMainStrings6.paste_text

public actual val SharedRes.strings.pasuk_example: StringResource
  get() = CommonMainStrings6.pasuk_example

public actual val SharedRes.strings.pasuk_example_bereshit: StringResource
  get() = CommonMainStrings6.pasuk_example_bereshit

public actual val SharedRes.strings.pasuk_lehazmana: StringResource
  get() = CommonMainStrings6.pasuk_lehazmana

public actual val SharedRes.strings.pasuk_str: StringResource
  get() = CommonMainStrings6.pasuk_str

public actual val SharedRes.strings.pdf_email_dialog_email: StringResource
  get() = CommonMainStrings6.pdf_email_dialog_email

public actual val SharedRes.strings.pdf_email_dialog_first_name: StringResource
  get() = CommonMainStrings6.pdf_email_dialog_first_name

public actual val SharedRes.strings.pdf_email_dialog_invalid_email: StringResource
  get() = CommonMainStrings6.pdf_email_dialog_invalid_email

public actual val SharedRes.strings.pdf_email_dialog_last_name: StringResource
  get() = CommonMainStrings6.pdf_email_dialog_last_name

public actual val SharedRes.strings.pdf_email_dialog_save_details: StringResource
  get() = CommonMainStrings6.pdf_email_dialog_save_details

public actual val SharedRes.strings.pdf_email_dialog_title: StringResource
  get() = CommonMainStrings6.pdf_email_dialog_title

public actual val SharedRes.strings.perek_a: StringResource
  get() = CommonMainStrings6.perek_a

public actual val SharedRes.strings.perek_str: StringResource
  get() = CommonMainStrings6.perek_str
